module.exports = __webpack_public_path__ + "img/qr_sph.69ca0628.png";